// src/features/reportAdmin/reportAdminSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

export const saveForumReportAdmin = createAsyncThunk(
  "reportAdmin/saveReport",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await agent.post(
        API.SUBMIT_FORUM_REPORT_ADMIN,
        payload
      );

      return {
        success: true,
        message:
          response.data?.message || "Report submitted successfully!",
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message
      );
    }
  }
);

const reportAdminSlice = createSlice({
  name: "reportAdmin",
  initialState: {
    saving: false,
    success: null,
    error: null,
  },
  reducers: {
    clearReportStatus(state) {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveForumReportAdmin.pending, (state) => {
        state.saving = true;
        state.error = null;
        state.success = null;
      })
      .addCase(saveForumReportAdmin.fulfilled, (state, action) => {
        state.saving = false;
        state.success = action.payload.message;
      })
      .addCase(saveForumReportAdmin.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { clearReportStatus } = reportAdminSlice.actions;
export default reportAdminSlice.reducer;
